import axios from '@/libs/axios'

export default {
    namespaced: true,
    state: {
        metricas: {
            mrr: 0,
            clientes_ativos: 0,
            em_trial: 0,
            inadimplentes: 0,
            cortesias: 0,
            cancelados_mes: 0,
            total_com_acesso: 0,
        },
        assinaturas: [],
        loading: false,
        pagination: {
            current_page: 1,
            last_page: 1,
            per_page: 15,
            total: 0,
        },
        filtros: {
            status: '',
            plano_base_id: '',
            ciclo: '',
            busca: '',
        },
    },
    mutations: {
        SET_METRICAS(state, metricas) {
            state.metricas = metricas
        },
        SET_ASSINATURAS(state, data) {
            state.assinaturas = data.data
            state.pagination = {
                current_page: data.current_page,
                last_page: data.last_page,
                per_page: data.per_page,
                total: data.total,
            }
        },
        SET_LOADING(state, loading) {
            state.loading = loading
        },
        SET_FILTROS(state, filtros) {
            Object.keys(filtros).forEach(function(key) {
                state.filtros[key] = filtros[key]
            })
        },
    },
    actions: {
        async fetchMetricas({ commit }) {
            var { data } = await axios.get('/api/admin/assinaturas/metricas')
            commit('SET_METRICAS', data)
        },

        async fetchAssinaturas({ commit, state }, page) {
            if (page === undefined) page = 1
            commit('SET_LOADING', true)
            try {
                var params = {
                    page: page,
                    per_page: state.pagination.per_page,
                    status: state.filtros.status,
                    plano_base_id: state.filtros.plano_base_id,
                    ciclo: state.filtros.ciclo,
                    busca: state.filtros.busca,
                }
                // Remove filtros vazios
                Object.keys(params).forEach(function(key) {
                    if (!params[key]) delete params[key]
                })

                var { data } = await axios.get('/api/admin/assinaturas/listar', { params: params })
                commit('SET_ASSINATURAS', data)
            } finally {
                commit('SET_LOADING', false)
            }
        },

        async concederCortesia(_, payload) {
            return axios.post('/api/admin/assinaturas/cortesia', payload)
        },

        async estenderVencimento(_, payload) {
            return axios.post('/api/admin/assinaturas/estender', payload)
        },

        async cancelarAssinatura(_, payload) {
            return axios.post('/api/admin/assinaturas/cancelar', payload)
        },

        async alterarPlano(_, payload) {
            return axios.post('/api/admin/assinaturas/alterar-plano', payload)
        },
    },
}
